import React from "react";

const AboutUsPage: React.FC = () => {
  return <div>AboutUsPage</div>;
};

export default AboutUsPage;
